import Vlitejs from './../libs/vlitejs-8.1.1/dist/vlite.js';
import VlitejsYoutube from './../libs/vlitejs-8.1.1/dist/providers/youtube.js';

Vlitejs.registerProvider('youtube', VlitejsYoutube);

const videos = document.querySelectorAll('.vlite-js');

for (let i=0; i < videos.length; i++) {
    videos[i].id = `vlitejs-${i}`;
    const video = document.querySelector(`#vlitejs-${i}`);

    // Check if this player is for a YouTube video
    const youtubeId = video.getAttribute('data-youtube-id');

    if (youtubeId) {
        const posterUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

        new Vlitejs(video, {
            options: {
                controls: true,
                autoplay: false,
                playPause: true,
                progressBar: true,
                time: true,
                volume: true,
                fullscreen: true,
                bigPlay: true,
                playsinline: true,
                loop: true,
                poster: posterUrl,
                muted: false,
                autoHide: true,
            },
            provider: ['youtube'],
        });
    } else {
        new Vlitejs(video, {
            options: {
                controls: true,
                autoplay: false,
                playPause: true,
                progressBar: true,
                time: true,
                volume: true,
                fullscreen: true,
                bigPlay: true,
                playsinline: true,
                loop: true,
                muted: false,
                autoHide: true,
            },
            provider: ['html5'],
        });
    }
};